<template>
    <div style="width: 100%;height: 100%;position: relative;">
        <div ref="radarchart" style="width: 100%;height: 100%;"></div>
        <!-- 用图片替代legend -->
        <img 
            src="../../../assets/image/legend.png" 
            style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%);" 
            alt="legend"
        />
    </div>
</template>
<script>
import { t } from '@wangeditor/editor';
import * as echarts from 'echarts'
export default {
    props: {
        indicator: Array,
        series: Array,
        title: Array,
        tooltip: Object,
        textColor: {
            type: String,
            default: '#fff' // 默认白色字体
        }
    },
    data() {
        return {
            options: {
                color: ['#1571E7', '#00FF87', '#FBBC06', '#FF917C'],
                title: {
                    show: false
                },
                legend: {
                    show: false, // 始终不显示legend
                    right: '0',
                    top: 'center',
                    textStyle: {
                        color: '#fff' // 默认白色
                    },
                    orient: 'vertical', // 垂直排列
                    itemGap: 20 // 图例项之间的间隔
                },

                textStyle: {
                    color: '#fff' // 默认白色
                },
                tooltip: {
                    show: true
                },
                radar: {
                    // shape: 'circle',
                    radius: '68%',
                    position: 'left', // 改为字符串形式
                    center: ['35%', '50%'], // 更精确地控制位置，左侧30%处，垂直居中
                    axisName: {
                        color: '#fff' // 默认白色
                    },
                    indicator: [
                        // { name: 'Sales', max: 6500 },
                        // { name: 'Administration', max: 16000 },
                        // { name: 'Information Technology', max: 30000 },
                        // { name: 'Customer Support', max: 38000 },
                        // { name: 'Development', max: 52000 },
                        // { name: 'Marketing', max: 25000 }
                    ]
                },
                series: [
                    // {
                    //     type: 'radar',
                    //     data: [
                    //         {
                    //             value: [4200, 3000, 20000, 35000, 50000, 18000],
                    //             name: '得分'
                    //         }
                    //     ]
                    // }
                ]
            }
        }
    },
    watch: {
        series(val) {
            this.updateOptions()
            this.init()
        },
        textColor() {
            this.updateOptions()
            this.init()
        }
    },
    mounted() {
        this.updateOptions()
        this.init()
    },
    methods: {
        updateOptions() {
            // 防御性处理：确保 indicator/series 为数组，避免 ECharts 内部 push undefined 报错
            this.options.radar.indicator = Array.isArray(this.$props.indicator) ? this.$props.indicator : []
            this.options.series = Array.isArray(this.$props.series) ? this.$props.series : []
            // 更新颜色设置
            this.options.legend.textStyle.color = this.textColor
            this.options.textStyle.color = this.textColor
            this.options.radar.axisName.color = this.textColor
            if (this.$props.title) {
                // 即使有title也不显示legend
                // this.options.legend.show = true
                this.options.legend.data = this.$props.title
            }
            if (this.$props.tooltip) {
                this.options.tooltip = this.$props.tooltip
            }
        },
        init() {
            if (!this.$refs.radarchart) return
            var myChart = echarts.init(this.$refs.radarchart)
            myChart.setOption(this.options)
            window.addEventListener('resize', function () {
                if (myChart) myChart.resize();
            });
        }
    }
}
</script>
<style scoped></style>